/**
 * Field Types
 */
export const TYPES = {
    STRING: 'string',
    TEXT: 'text',
    BOOL: 'bool',
    INT: 'int',
    DECIMAL: 'decimal',
    NUMBER: 'number',
    DATE: 'date',
    SELECT: 'select',

    // Custom types
    FLAG: 'flag',
    DATETIME: 'datetime',
    LINK: 'link',
    EMAIL: 'email',
}

/**
 * Field Formats
 */
export const FORMATS = {
    [TYPES.DATE]: 'DD/MM/YYYY',
    [TYPES.DATETIME]: 'HH:mm DD/MM/YYYY',
}

export const ISO_DATETIME = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

/**
 * Inputs
 */
export const INPUTS = {
    BOOL: 'bool',
    TEXT: 'text',
    NUMBER: 'number',
    DATE: 'date',
    SELECT: 'select',
}

export const FIELD_INPUTS = {
    [TYPES.BOOL]: INPUTS.BOOL,
    [TYPES.STRING]: INPUTS.TEXT,
    [TYPES.TEXT]: INPUTS.TEXT,
    [TYPES.INT]: INPUTS.NUMBER,
    [TYPES.DECIMAL]: INPUTS.NUMBER,
    [TYPES.NUMBER]: INPUTS.NUMBER,
    [TYPES.DATE]: INPUTS.DATE,
    [TYPES.SELECT]: INPUTS.SELECT,

    // Custom
    [TYPES.FLAG]: INPUTS.SELECT,
    [TYPES.DATETIME]: INPUTS.DATE,
    [TYPES.LINK]: INPUTS.TEXT,
    [TYPES.EMAIL]: INPUTS.TEXT,
}

/**
 * Outputs
 */
export const OUTPUTS = {
    BOOL: 'bool',
    DEFAULT: 'default',
    NUMBER: 'number',
    DECIMAL: 'decimal',
    DATE: 'date',
    SELECT: 'select',

    // Custom
    FLAG: 'flag',
    DATETIME: 'datetime',
    LINK: 'link',
    EMAIL: 'email',
}

export const FIELD_OUTPUTS = {
    [TYPES.BOOL]: OUTPUTS.BOOL,
    [TYPES.STRING]: OUTPUTS.DEFAULT,
    [TYPES.TEXT]: OUTPUTS.DEFAULT,
    [TYPES.INT]: OUTPUTS.NUMBER,
    [TYPES.NUMBER]: OUTPUTS.NUMBER,
    [TYPES.DECIMAL]: OUTPUTS.DECIMAL,
    [TYPES.DATE]: OUTPUTS.DATE,
    [TYPES.SELECT]: OUTPUTS.SELECT,

    // Custom
    [TYPES.FLAG]: OUTPUTS.FLAG,
    [TYPES.DATETIME]: OUTPUTS.DATETIME,
    [TYPES.LINK]: OUTPUTS.LINK,
    [TYPES.EMAIL]: OUTPUTS.EMAIL,
}

/**
 * Select field types
 */
export const FIELD_SELECT = [
    { key: TYPES.STRING, label: 'Short text' },
    { key: TYPES.TEXT, label: 'Long text' },
    { key: TYPES.LINK, label: 'Link' },
    { key: TYPES.EMAIL, label: 'Email' },
    { key: TYPES.INT, label: 'Number' },
    { key: TYPES.DECIMAL, label: 'Decimal' },
    { key: TYPES.BOOL, label: 'Yes / No' },
    { key: TYPES.DATE, label: 'Date' },
    { key: TYPES.DATETIME, label: 'Datetime' },
    { key: TYPES.SELECT, label: 'Select' },
    { key: TYPES.FLAG, label: 'Flag country' },
]

export default {
    TYPES,
    FORMATS,
    FIELD_INPUTS,
    FIELD_OUTPUTS,
    FIELD_SELECT,
}
